<template>
  <div class="content">
    <div class="row">
      <div class="col-6">
        <h2 class="font-light">Create Question</h2>
      </div>
      <div class="col-6 u-vertical-center">
        <!-- Action Buttons -->
        <div class="form-group">
          <a href="#question-preview" class="action-button">
            <button class="btn-light">
              <span class="icon">
                <i class="fa-wrapper fa fa-glasses"></i>
              </span>
              <span>Preview</span>
            </button>
          </a>
          <button class="btn-primary action-button" v-on:click="save">
            <loading-spinner v-show="saving"></loading-spinner>
            <i class="fa-wrapper fa fa-upload" v-show="!saving"></i>
            <span>Save</span>
          </button>
          <router-link
            :to="{ name: 'question-index' }"
            class="action-button-link"
          >
            <button class="btn-info action-button">
              <span class="icon">
                <i
                  class="fa-wrapper fa fa-reply normal-icon"
                  aria-hiden="true"
                ></i>
              </span>
              <span>Index</span>
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <server-error v-bind:error="error.serverError"></server-error>
    <!-- There's no question info as the question doesn't exist =) -->
    <!-- The form to edit the question -->
    <question-form
      v-bind:question="question"
      v-bind:error="error"
      v-on:save="save"
    ></question-form>
    <div class="panel">
      <div class="btn-container u-fill-width u-text-right">
        <button class="btn-primary action-button" v-on:click="save">
          <loading-spinner v-show="saving"></loading-spinner>
          <i class="fa-wrapper fa fa-upload" v-show="!saving"></i>
          Save
        </button>
      </div>
    </div>
    <question-preview v-bind:question="question"></question-preview>
  </div>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";
import QuestionForm from "@/components/questions/QuestionForm";
import QuestionPreview from "@/components/questions/QuestionPreview";
import ServerError from "@/components/ServerError";
import { scrollToTop } from "@/functions/scrollToTop";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "question-create",
  components: {
    QuestionForm,
    QuestionPreview,
    ServerError,
    LoadingSpinner
  },
  data: function() {
    return {
      question: {
        // Default values for the form =)
        marks: 1,
        is_active: true
      },
      saving: false,
      success: false
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  methods: {
    validate() {
      let is_valid = true;
      if (!this.question.topic) {
        this.$store.commit("core/setError", {
          topic: "A topic must be selected."
        });
        is_valid = false;
      }
      if (!this.question.text || this.question.text == "") {
        this.$store.commit("core/setError", {
          text: "The question text cannot be blank."
        });
        is_valid = false;
      }
      if (!this.question.answer || this.question.answer == "") {
        this.$store.commit("core/setError", {
          answer: "The correct answer must be entered."
        });
        is_valid = false;
      }
      return is_valid;
    },
    save() {
      scrollToTop();
      this.$store.commit("core/clearErrors");
      this.success = false;
      const is_valid = this.validate();
      if (!is_valid) {
        return;
      }
      this.saving = true;
      this.$store
        .dispatch("questions/createQuestion", this.question)
        .then(result => {
          this.saving = false;
          if (!result) {
            this.success = false;
          } else {
            this.$router.push({
              name: "question",
              params: { id: result }
            });
            this.success = true;
          }
        });
    },
    closeSuccess: function() {
      this.success = false;
    }
  }
};
</script>
